// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_eu-2";
export var aiChatCartContainerExit = "_eu-4";
export var aiChatContainerLarge = "_eu-0";
export var aiChatContainerSmall = "_eu-1";
export var aiChatIcon = "_eu-6";
export var slideInFromRight = "_eu-3";
export var slideOutToRight = "_eu-5";